/*
  Un card pe culoare, optional, pe paginile de colectie.

  Pornit din setarea sectiunii "Collection container" (reem_split). Cardurile
  clonate duc toate la acelasi produs, cu culoarea preselectata (?variant=),
  deci Google vede un produs, clienta vede fiecare culoare ca un card.

  Foloseste datele de pe punctele de culoare (data-variant-id, data-media-id)
  si functia window.reemShowColor din blocul reem-color-dots.
*/
(function () {
  const list = document.querySelector('results-list[data-reem-split]');
  if (!list) return;

  const mode = list.dataset.reemSplit;
  const max = Number(list.dataset.reemSplitMax) || 12;
  const count = Number(list.dataset.reemCount) || 0;
  if (mode === 'off') return;
  if (mode === 'small' && count > max) return;

  function splitItem(item) {
    if (item.dataset.reemSplit || item.dataset.reemClone) return;
    item.dataset.reemSplit = '1';
    const dots = item.querySelectorAll('.reem-dots__dot');
    if (dots.length < 2) return;
    const active = item.querySelector('.reem-dots__dot.is-active') || dots[0];
    let anchor = item;
    dots.forEach((dot) => {
      if (dot === active) return;
      if (!dot.dataset.mediaId) return;
      const clone = item.cloneNode(true);
      clone.removeAttribute('id');
      delete clone.dataset.reemSplit;
      clone.dataset.reemClone = '1';
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      anchor.insertAdjacentElement('afterend', clone);
      anchor = clone;
      const apply = () => {
        const card = clone.querySelector('product-card');
        const cloneDot = [...clone.querySelectorAll('.reem-dots__dot')].find((d) => d.dataset.variantId === dot.dataset.variantId);
        if (card && cloneDot && window.reemShowColor) window.reemShowColor(card, cloneDot);
      };
      // asteapta ca elementele custom din clona sa se initializeze
      Promise.all([
        customElements.whenDefined('product-card'),
        customElements.whenDefined('slideshow-component'),
      ]).then(() => requestAnimationFrame(apply));
    });
  }

  function run() {
    list.querySelectorAll('li.product-grid__item').forEach(splitItem);
  }

  const start = () => {
    run();
    new MutationObserver(() => run()).observe(list, { childList: true, subtree: true });
  };
  if (window.reemShowColor) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
